import { noop } from 'ui-components/default-props/noop';

import { ConfigureShipmentSectionContent } from './configure-shipment-section-content';
import { ConfigureShipmentSectionHeaderContent } from './configure-shipment-section-header-content';
import { OrdersSidebarSection } from '../orders-sidebar-section';

/**
 * @param {object} props
 * @param {boolean} [props.open]
 * @param {(open: boolean) => void} [props.onClick]
 * @param {boolean} [props.isCancelled]
 * @param {boolean} [props.isAwaitingPayment]
 * @param {string} [props.salesOrderId]
 * @param {(fulfillmentPlanId: string) => void} [props.restore]
 * @param {object} [props.dragHandleProps]
 * @param {boolean} [props.isCreatingReturn]
 * @param {boolean} [props.shouldShowShipmentWidget]
 * @param {boolean} [props.shouldShowCompletedIndicator]
 * @param {string} [props.fulfillmentPlanId]
 * @returns {JSX.Element}
 */
export const ConfigureShipmentSection = ({
  open = false,
  onClick = noop,
  isCancelled = false,
  isAwaitingPayment = false,
  salesOrderId = '',
  restore = noop,
  dragHandleProps,
  isCreatingReturn = false,
  shouldShowShipmentWidget = false,
  shouldShowCompletedIndicator = false,
  fulfillmentPlanId = '',
}) => {
  const headerContent = (
    <ConfigureShipmentSectionHeaderContent
      fulfillmentPlanId={fulfillmentPlanId}
      isSectionExpanded={open}
      shouldShowShipmentWidget={shouldShowShipmentWidget}
    />
  );

  const sectionContent = (
    <ConfigureShipmentSectionContent
      fulfillmentPlanId={fulfillmentPlanId}
      isAwaitingPayment={isAwaitingPayment}
      isCancelled={isCancelled}
      isCreatingReturn={isCreatingReturn}
      restore={restore}
      salesOrderId={salesOrderId}
      shouldShowCompletedIndicator={shouldShowCompletedIndicator}
      shouldShowShipmentWidget={shouldShowShipmentWidget}
    />
  );

  return (
    <OrdersSidebarSection
      dragHandleProps={dragHandleProps}
      headerContent={headerContent}
      isExpanded={open}
      sectionContent={sectionContent}
      toggleIsExpanded={onClick}
    />
  );
};
